export const ONBOARDING_COMPLETED_KEY = 'onboarding_completed';
export const ONBOARDING_TAGS_KEY = 'onboarding_tags';

export const hasCompletedOnboarding = (user) => {
  return Boolean(user?.app_settings?.[ONBOARDING_COMPLETED_KEY]);
};

export const getOnboardingTags = (user) => {
  const tags = user?.app_settings?.[ONBOARDING_TAGS_KEY];
  return Array.isArray(tags) ? tags.filter(Boolean) : [];
};

export const getPostAuthDefaultRoute = (user) => {
  return hasCompletedOnboarding(user) ? '/new' : '/onboarding';
};

export const buildOnboardingProfileUpdate = ({
  existingSettings = {},
  selectedTags = [],
  existingInterests = '',
  interestSummary = '',
}) => {
  const normalizedTags = Array.from(new Set(selectedTags.filter(Boolean)));

  return {
    interests: interestSummary || existingInterests || '',
    app_settings: {
      ...existingSettings,
      [ONBOARDING_COMPLETED_KEY]: true,
      [ONBOARDING_TAGS_KEY]: normalizedTags,
    },
  };
};
